import { useEffect } from "react";
import { useLocation, useParams } from "react-router";
import { ROUTES } from "../routes";
import { useClientPortalLocation } from "./useClientPortalLocation";
import { useClientPortalConfigContext } from "../context";
import { getBookGroupBookingLabel } from "../utils/groupBookingLabel";

const TITLE_SUFFIX = " - Client Bookings Zanda";

export function usePageTitle() {
    const location = useLocation();
    const params = useParams();
    const clientPortalPath = useClientPortalLocation();
    const { clientPortalConfig } = useClientPortalConfigContext();
    useEffect(() => {
        // Get the current path without the base client portal URL
        let pathParts = clientPortalPath.split("/").filter((part) => part !== "");

        // Remove parameter values from the path by excluding known param values
        const paramValues = Object.values(params);
        pathParts = pathParts.filter((part) => !paramValues.includes(part));

        if (pathParts.length === 0) {
            document.title = "Home" + TITLE_SUFFIX;
            return;
        }

        // Find the matching route by checking the remaining path parts
        const matchedRoute = Object.values(ROUTES).find((routeConfig) => {
            const routePath = routeConfig.urlPath;

            // Check if the route path matches any of the remaining path parts
            return pathParts.includes(routePath);
        });

        const pageTitle =
            matchedRoute?.urlPath === ROUTES.CLASS_BOOKING.urlPath
                ? getBookGroupBookingLabel(clientPortalConfig?.groupBookingLabel)
                      .toLowerCase()
                      .replace(/^./, (value) => value.toUpperCase())
                : (matchedRoute?.pageTitle ?? "Home");
        document.title = pageTitle + TITLE_SUFFIX;
    }, [location.pathname, params, clientPortalConfig, clientPortalPath]);
}
